export default {
    template:   require('./loading-text.vue')
};
